import axios from "axios";
import { getAuth } from "firebase/auth";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3010";

/**
 * Lấy token của user hiện tại
 */
const getAuthToken = async () => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (user) {
    return user.getIdToken();
  }
  // Không trả null — tránh sinh header "Bearer null" khiến backend 401.
  // Throw để caller hiển thị toast rõ ràng và dừng flow đúng nghĩa.
  const err = new Error("Phiên đăng nhập đã hết hạn hoặc chưa sẵn sàng. Vui lòng tải lại trang.");
  err.code = "NOT_AUTHENTICATED";
  throw err;
};

/**
 * Kiểm tra trạng thái cài đặt plugin SEO Connector trên website
 * @param {Object} siteData - Dữ liệu website { url, username, password }
 * @returns {Promise<Object>} - Kết quả health check
 */
export const checkSeoConnector = async (siteData) => {
  try {
    const token = await getAuthToken();
    const response = await axios.post(
      `${API_BASE_URL}/api/wordpress-connector/check`,
      {
        url: siteData.url,
        username: siteData.username,
        password: siteData.password,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Lỗi khi kiểm tra SEO Connector:", error);

    if (error?.code === "NOT_AUTHENTICATED") {
      toast.error(error.message || "Phiên đăng nhập hết hạn, vui lòng tải lại trang.");
    } else if (error.response?.status === 401) {
      toast.error("Phiên đăng nhập hết hạn, vui lòng tải lại trang và thử lại.");
    } else if (error.code === "ECONNABORTED" || !error.response) {
      toast.error("Không thể kết nối đến máy chủ. Vui lòng kiểm tra lại mạng.");
    }

    throw error;
  }
};

/**
 * Trả về URL để download file plugin ZIP (tạo trực tiếp từ Backend API)
 * @returns {string}
 */
export const getConnectorDownloadUrl = () => {
  return `${API_BASE_URL}/api/wordpress-connector/download-plugin`;
};
